import { Controller } from '@hotwired/stimulus'

const globalCallbacks = window as unknown as Record<string, () => void>

// Connects to data-controller="recaptcha-submit"
export default class extends Controller<HTMLFormElement> {
  static values = {
    callback: String
  }

  declare readonly callbackValue: string

  // reCAPTCHA は data-callback に書いた名前で window の関数を探して呼ぶので、その名前で submit を登録する
  // form.submit() では同意チェックボックスの required 検証が飛ばされるため requestSubmit() を使う
  connect(): void {
    globalCallbacks[this.callbackValue] = () => this.element.requestSubmit()
  }

  disconnect(): void {
    delete globalCallbacks[this.callbackValue]
  }
}
